import React, { useState, useEffect, useCallback } from "react";
import { Range, getTrackBackground } from "react-range";
import styles from "./RangeSlider.module.scss";

const RangeSlider = ({
  min,
  max,
  step = 1,
  values,
  onChange,
  onFinalChange,
  minLabel = "최소",
  maxLabel = "최대",
  className,
}) => {
  const safeMin = values[0] == null ? min : Math.max(min, Math.min(values[0], max));
  const safeMax = values[1] == null ? max : Math.max(min, Math.min(values[1], max));
  const [local, setLocal] = useState([safeMin, safeMax]);

  useEffect(() => {
    setLocal([safeMin, safeMax]);
  }, [safeMin, safeMax]);

  const handleChange = useCallback((vals) => {
    setLocal(vals);
    if (onChange) {
      onChange([
        vals[0] <= min ? null : vals[0],
        vals[1] >= max ? null : vals[1],
      ]);
    }
  }, [min, max, onChange]);

  const handleFinalChange = useCallback((vals) => {
    setLocal(vals);
    if (onFinalChange) {
      onFinalChange([
        vals[0] <= min ? null : vals[0],
        vals[1] >= max ? null : vals[1],
      ]);
    }
  }, [min, max, onFinalChange]);

  return (
    <div className={`${styles.container} ${className || ""}`}>
      <Range
        values={local}
        step={step}
        min={min}
        max={max}
        onChange={handleChange}
        onFinalChange={handleFinalChange}
        renderTrack={({ props, children }) => (
          <div
            className={styles.trackWrapper}
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={props.style}
          >
            <div
              ref={props.ref}
              className={styles.track}
              style={{
                background: getTrackBackground({
                  values: local,
                  colors: ["rgba(112,115,124,0.16)", "#0868f4", "rgba(112,115,124,0.16)"],
                  min,
                  max,
                }),
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props, index }) => {
          const { key, ...rest } = props;
          return (
            <div key={key} {...rest} className={styles.thumb} />
          );
        }}
      />
      <div className={styles.labels}>
        <span>{minLabel}</span>
        <span>{maxLabel}</span>
      </div>
    </div>
  );
};

export default RangeSlider;
